module.exports = __webpack_public_path__ + "static/media/hall-P1.16b725a0.svg";